import React from 'react'
import ReactDOM from 'react-dom'
import ToggleBtn from './toggleBtn.jsx'
import Tooltip from 'wix-base-ui/lib/controls/tooltip'
import symbols from './symbols'
import _ from 'lodashParts'

let currentCaptureClickListener = null

class TextPopup extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            showPopup: false
        }
    }

    captureOuterClick(e) {
        const domNode = ReactDOM.findDOMNode(this)
        const nodesToCheck = [domNode]

        if (this.refs) {
            _.forEach(this.refs, ref => {
                const childNode = ReactDOM.findDOMNode(ref)
                nodesToCheck.push(childNode)
                //Check only first parent to catch the tooltip wrapper
                nodesToCheck.push(childNode.parentNode || childNode.parentElement)
            })
        }

        let isInnerClick = false

        _.forEach(nodesToCheck, node => {
            if (node.contains(e.target)) {
                isInnerClick = true

                return false
            }
        })

        if (!isInnerClick) {
            this.togglePopup(true)
        }
    }

    togglePopup(forceClose) {
        const showPopup = !this.state.showPopup && !forceClose
        this.setState({showPopup})

        if (showPopup) {
            this.registerClickListener()
        } else {
            this.unRegisterClickListener()
        }
    }

    registerClickListener() {
        currentCaptureClickListener = e => {this.captureOuterClick(e)}
        window.document.addEventListener('mousedown', currentCaptureClickListener, true)
    }

    unRegisterClickListener() {
        if (currentCaptureClickListener) {
            window.document.removeEventListener('mousedown', currentCaptureClickListener, true)
        }

        currentCaptureClickListener = null
    }

    getClonedChildren() {
        return React.Children.map(this.props.children, (element, idx) => React.cloneElement(element, {ref: idx}))
    }

    componentWillUnmount() {
        this.unRegisterClickListener()
    }

    render() {
        return (
            <Tooltip content={this.getClonedChildren()} isOpen={this.state.showPopup} closeOnMouseLeave={false} openOnMouseEnter={false} direction="top">
                <div className="richtext-textpopup-wrapper">
                    <ToggleBtn label={this.props.iconName}
                               className={'richtext-context-button ' + this.props.className}
                               value={this.state.showPopup}
                               disabled={this.props.disabled}
                               style={{width: this.props.width + 'px'}}
                               automationId={this.props.automationId}
                               onClick={() => this.togglePopup()}>
                        <span className="display-label">
                            {this.props.label}
                        </span>
                        <span className="symbol-arrow-down floating">
                            <svg className="symbol" {...symbols.arrowDown.svg}
                                 dangerouslySetInnerHTML={{__html: symbols.arrowDown.content}}>
                            </svg>
                        </span>
                    </ToggleBtn>
                </div>
            </Tooltip>
        )
    }
}

TextPopup.propTypes = {
    label: React.PropTypes.string,
    width: React.PropTypes.number,
    iconName: React.PropTypes.string
}

module.exports = TextPopup



// WEBPACK FOOTER //
// ./src/components/toolbar/textPopup.jsx